import React, { useState } from "react";
import {
  FaDesktop,
  FaMobileAlt,
  FaAndroid,
  FaUserTie,
  FaShoppingCart,
  FaGlobe,
} from "react-icons/fa";
import { MdShoppingCart } from "react-icons/md";
import Select_productss from "../../../assets/Docs/Buyers_Cart.png";
import cart_select from '../../../assets/AppImages/cart_select.png'

import { TagComponent } from "../Tabs";

const OrderCarts = () => {
  const [activeTab2, setActiveTab2] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];


  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            }`}

        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">
      {/* Panel Header */}




      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <MdShoppingCart className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">   Order Carts</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      {/* Intro Text */}
      <div className="bg-gray-50 p-6 rounded-2xl ">
        <p className="text-gray-700 text-start text-base leading-relaxed ">
          Each 'Buyer' on Selzor receives three separate Order Carts. This
          allows buyers to transfer items between carts and quickly finalise the
          one containing the most urgent items, while the other carts hold less
          time-sensitive products.
        </p>
      </div>

      <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start">
        Adding an item to the order cart will either place it in the selected
        cart or update it if it’s already there.
      </div>

      {/* Steps Section */}

      <div className="my-5">
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">


          {activeTab2 === "web" ? (
            <img
              src={Select_productss}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          ) : (
            <img
              src={cart_select}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          )}

        </div>
      </div>
    </div>
  );
};

export default OrderCarts;
